const EMAIL_KEY = 'userEmail'
const CONTROL_PLANE_KEY = 'selectedControlPlane'

export type Login = {
  email: string
  controlPlane: string
}

export function rememberLogin(login: Login) {
  window.localStorage.setItem(EMAIL_KEY, login.email)
  window.localStorage.setItem(CONTROL_PLANE_KEY, login.controlPlane)
}

export function getRememberedLogin(): Login | undefined {
  const email = window.localStorage.getItem(EMAIL_KEY)
  if (!email) {
    return
  }
  const controlPlane = window.localStorage.getItem(CONTROL_PLANE_KEY)
  if (!controlPlane) {
    return
  }
  return {
    email,
    controlPlane,
  }
}

export function forgetLogin() {
  window.localStorage.removeItem(EMAIL_KEY)
  window.localStorage.removeItem(CONTROL_PLANE_KEY)
}
